
export enum LoadingSise {
    XSmall = 'xsmall',
    Small = 'small',
    Normal = 'normal',
    Medium = 'medium',
    Large = 'large',
    XLarge = 'xlarge'
}
  